import { BillingDocumentsSection } from '@/pages/billing/billing-documents-section';

export const SubscriptionsHistoryPage = () => (
  <div className="space-y-4">
    <BillingDocumentsSection />
  </div>
);
